import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Observable } from 'rxjs';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-retailer-filter',
  templateUrl: './retailer-filter.component.html',
  styleUrls: ['./retailer-filter.component.less']
})
export class RetailerFilterComponent implements OnInit {
  showCategories: boolean = true;
  showAZ: boolean = false;
  showRecentlySelected: boolean = false;
  recentlySelectedRetailers: any[] = [];
  openCategoryList: any[] = [];
  retailerFilterActiveSubscription: Subscription;
  mapLoadedChangeSubscription: Subscription;
  randomRetailerSubscription: Subscription;
  toggleCategoryRetailersSubscription: Subscription;
  closeOnClickRef: any;
  showGoogleBusiness: boolean = false;
  isRetailerOn: boolean = true;
  retailerFiltersChangedSubscription: any;
  tilesLoadedSubscription: any;
  updateRecentlySelectedRetailersSubscription: any;
  fetchRetailerFilterDataSubscription: any;
  fetchOpenCategoryRetailersSubscription: any;
  toggleRooftopRetailerSelectionSubscription: any;
  toggleGoogleBusinessSubscription: any;
  resetRecentlySelectedRetailersSubscription: any;

  constructor(public mapsSidebarService: MapsSidebarService, public ref: ChangeDetectorRef,
   public elementRef: ElementRef) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.retailerFilterActiveSubscription = this.mapsSidebarService.retailerFilterActiveStream.subscribe((value)=> {
      if(value) {
        let w = (<any>window);
        document.addEventListener('click', this.closeOnClickRef, true);
        this.initializeMapLoadSubscription();
      }
    });
    this.initializeRandomRetailerSubscription();
  }

  ngAfterViewInit() {
    let w = <any>window;
    this.retailerFiltersChangedSubscription = w.Events.subscribe('retailerFiltersChanged',()=>{
      this.isRetailerOn = w.mapData.retailerFilterActive;
      this.showGoogleBusiness = w.mapData.showGoogleBusiness;
      w.overlayLayer.toggleGoogleBusiness(this.isRetailerOn && this.showGoogleBusiness);
      this.resetRecentlySelected();
      w.Events.publish('updateRecentlySelectedRetailers');

      w.Events.publish('detectChanges');
    });

    this.tilesLoadedSubscription = w.Events.subscribe('tilesLoaded', ()=>{
      w.Events.publish('fetchRetailerFilterData');
    });

    this.updateRecentlySelectedRetailersSubscription = w.Events.subscribe('updateRecentlySelectedRetailers', ()=>{
      this.addRecentlySearched(w.apiRetailer.filteredRetailers);
    });

    this.fetchRetailerFilterDataSubscription = w.Events.subscribe('fetchRetailerFilterData', ()=>{
      this.mapsSidebarService.showRetailerFilter && this.mapsSidebarService.fetchRetailerData();
    });

    this.fetchOpenCategoryRetailersSubscription = w.Events.subscribe('fetchOpenCategoryRetailers', ()=>{
      if(this.mapsSidebarService.retailerSearchValue && this.mapsSidebarService.retailerSearchValue.length > 0) {
        this.openCategoryList = [];
        for(let category of this.mapsSidebarService.retailerCategories) {
          this.openCategoryList.push(category.categoryId);
        }
      } else {
        if(this.openCategoryList.length > 0) {
          let str = '';
          for(let i = 0; i < this.openCategoryList.length; i++) {
            str = (i === 0) ? this.openCategoryList[i] : str + ',' + this.openCategoryList[i];
          }
          this.mapsSidebarService.retailerByCategoryIdsApiCall(str);
        }
      }
    });

    this.toggleCategoryRetailersSubscription = w.Events.subscribe('toggleCategoryRetailers', (data)=>{
      let retailers = [];
      for(let i=0; i < data.category.retailers.length; i++) {
        data.category.retailers[i].categoryId = data.category.categoryId;
        retailers.push(data.category.retailers[i]);
      }

      if(retailers.length > 0) {
        (<any>window).toggleRetailerFilter(retailers, data.toggle);
      }

      if(data.toggle) {
        this.addRecentlySearched(data.category.retailers);
      }
      (<any>window).Events.publish('detectChanges');
    });

    this.toggleRooftopRetailerSelectionSubscription = w.Events.subscribe('toggleRooftopRetailerSelection', (data)=>{
      if(data) {
        this.toggleRooftopRetailerSelection(data);
      }
    });

    this.toggleGoogleBusinessSubscription = w.Events.subscribe('toggleGoogleBusiness', (toggle)=>{
      this.showGoogleBusiness = toggle;
      w.setMapDataProperty('showGoogleBusiness', this.showGoogleBusiness);
      w.overlayLayer.toggleGoogleBusiness(this.showGoogleBusiness);
      w.localStorageHandler.updateMapDataLocalStorage();
      w.Events.publish('detectChanges');
    });

    let retailerSearchInputElement = document.getElementById('retailer-filter-search-input');
    if(retailerSearchInputElement) {
      Observable.fromEvent(retailerSearchInputElement, 'input')
      .debounceTime(500)
      .subscribe((event: any) => {
        this.mapsSidebarService.retailerSearchValue = event.target.value;
        this.showAZSection();
        this.mapsSidebarService.azRetailerPageNumber = 1;
        this.mapsSidebarService.viewportAZRetailersAllFetched = false;
        this.mapsSidebarService.azRetailerApiCall();
        w.Events.publish('detectChanges');
      });
    }
    this.resetRecentlySelectedRetailersSubscription = w.Events.subscribe('resetRecentlySelectedRetailers', (toggle)=> {
      if(toggle) {
        this.resetCheckedRetailers();
      }
    });    
  }

  apiCallsAfterInput() {
    if(this.mapsSidebarService.retailerSearchValue.length === 0) {
      this.openCategoryList = [];
    }
    this.mapsSidebarService.azRetailerPageNumber = 1;
    this.mapsSidebarService.viewportAZRetailersAllFetched = false;
    this.mapsSidebarService.azRetailerApiCall();
    this.mapsSidebarService.retailerCategoryApiCall();
    (<any>window).Events.publish('detectChanges');
  }

  initializeMapLoadSubscription() {
    this.mapLoadedChangeSubscription = this.mapsSidebarService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        this.mapsSidebarService.fetchRetailerData();
      }
    });
  }

  initializeRandomRetailerSubscription() {
    this.randomRetailerSubscription = this.mapsSidebarService.randomRetailerStream.subscribe((value) => {
      if(value) {
        this.mapsSidebarService.fetchRandomRetailers(3).subscribe((res: any) => {
          this.mapsSidebarService.randomRetailers = res;
          this.toggle3RandomRetailers();
        });
      }
    });
  }

  closeOnOutsideClick(event: Event) {
    if (event.target !== this.elementRef.nativeElement
        && !this.elementRef.nativeElement.contains(event.target)
        && !(<any>window).hasClass(event.target, 'layer-filter-sub-header')
        && !(<any>window).hasClass(event.target, 'toggle-layers-holder')
        && !(<any>window).hasClass(event.target, 'filter-counter')
        && !(<any>window).hasClass(event.target, 'filter-icon')
        && !(<any>window).hasClass(event.target, 'arrow-icon')) {
      this.closeRetailerFilter();
      document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  showCategoriesSection() {
    this.showCategories = true;
    this.showAZ = false;
    (<any>window).Events.publish('detectChanges');
  }

  showAZSection() {
    this.showCategories = false;
    this.showAZ = true;
    (<any>window).Events.publish('detectChanges');
  }

  closeRetailerFilter() {
    this.mapsSidebarService.showRetailerFilter = false;
    (<any>window).localStorageHandler.updateSideBarToLS();
    (<any>window).Events.publish('detectChanges');
  }

  toggleRetailers(event, retailer) {
    let retailers = [];
    retailers.push(retailer);
    (<any>window).toggleRetailerFilter(retailers, event.target.checked);
    if(event.target.checked) {
      this.addRecentlySearched(retailers);
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggle3RandomRetailers() {
    let w = (<any>window),
        retailers = [];

    this.mapsSidebarService.randomRetailers = Array.isArray(this.mapsSidebarService.randomRetailers)? this.mapsSidebarService.randomRetailers: [];
    for(var i=0; i < this.mapsSidebarService.randomRetailers.length; i++) {
      retailers.push(this.mapsSidebarService.randomRetailers[i]);
    }

    w.toggleRetailerFilter(retailers, true);
    this.addRecentlySearched(this.mapsSidebarService.randomRetailers);
    w.addClass(w.domBody, 'first-time-user');
    (<any>window).Events.publish('detectChanges');

    setTimeout(() => {
      w.removeClass(w.domBody, 'first-time-user');
    }, 8000);
  }

  resetRecentlySelected() {
    this.recentlySelectedRetailers = [];
  }

  addRecentlySearched(retailerObjects) {
    for(let i=0; i < retailerObjects.length; i++) {
      let isRetailerPresent = this.checkIfRetailerPresentInRecentlySelected(retailerObjects[i].retailerId);
      if(!isRetailerPresent) {
        this.recentlySelectedRetailers.unshift(retailerObjects[i]);
      }
    }
    this.ref.detectChanges();
    setTimeout(() => {
      this.changeFilterTopStyling();
    },0); 
  }

  checkIfRetailerPresentInRecentlySelected(retailerId) {
    return this.recentlySelectedRetailers.some((obj)=>{
      return obj.retailerId === retailerId;
    })
  }

  isRetailerChecked(retailerId) {
    return ((<any>window).apiRetailer.filteredRetailers)?
    (<any>window).apiRetailer.filteredRetailers.some((obj)=>{
      return obj.retailerId === retailerId;
    }):
    false;
  }

  changeFilterTopStyling() {
    let categoryFilterScrollHeight = document.getElementById('category-filter-scroll-height'), 
      recentlySelectedFilter = document.getElementById('filter-recently-selected-child'),
      filterRecentlySelectedScrollbar = document.getElementById('filter-recently-selected-scrollbar'), retailerFilterTopCss;
    let retailerFilterContainerHeight = (document.getElementById('retailer-filter-container').offsetHeight)/2;
    if (recentlySelectedFilter) {
      let recentlySelectedFilterHeight = recentlySelectedFilter.offsetHeight;
      let retailerFilterTop = recentlySelectedFilterHeight + 205 + 17; // Top Fixed Height + Margins + Paddings + Adjustments
      if(retailerFilterTop < retailerFilterContainerHeight) { 
        retailerFilterTopCss = retailerFilterTop + 'px'; 
        filterRecentlySelectedScrollbar.style.bottom = 'initial'; 
        if(this.showRecentlySelected) { categoryFilterScrollHeight.style.marginTop = '4px'; } 
        else { categoryFilterScrollHeight.style.marginTop = '0px'; }
      } else { retailerFilterTopCss = retailerFilterContainerHeight + 'px'; 
        filterRecentlySelectedScrollbar.style.bottom = '50%'; 
        categoryFilterScrollHeight.style.marginTop = '0px'; 
      }
      categoryFilterScrollHeight.style.top = 'calc(' + retailerFilterTopCss + ' + 10px)';
    } else {
      let retailerFilterTopCss = document.getElementById('filter-recently-selected').offsetHeight + 'px';
      categoryFilterScrollHeight.style.top = 'calc(' + retailerFilterTopCss + ' + 205px + 7px)';
    }
  }

  isRecentlySelectedChecked() {
    let w = (<any>window);
    if(w.mapData) {
      let checked = true;
      for(let recentSelectedRetailer of this.recentlySelectedRetailers) {
        let retailerExists = w.apiRetailer.filteredRetailers.some((obj)=>{
          return obj.retailerId === recentSelectedRetailer.retailerId;
        });
        if(!retailerExists) {
          checked = false;
          break;
        }
      }
      return checked && w.apiRetailer.filteredRetailers.length>0 && this.recentlySelectedRetailers.length>0;
    } else {
      return false;
    }
  }

  isCategoryListHidden(categoryId) {
    return (this.openCategoryList.indexOf(categoryId) === -1);
  }

  showCategoryList(categoryId, index) {
    if(this.openCategoryList.indexOf(categoryId) === -1) {
      this.openCategoryList.push(categoryId);
      this.fetchCategoryRetailers(categoryId, index);
    } else {
      this.openCategoryList.splice(this.openCategoryList.indexOf(categoryId), 1);
    }
    (<any>window).Events.publish('detectChanges');
  }

  fetchCategoryRetailers(categoryId, index) {
    this.mapsSidebarService.retailerCategories[index].retailers.length === 0 &&
    this.mapsSidebarService.retailerByCategoryIdsApiCall(categoryId);
  }

  toggleRecentlySelected() {
    this.showRecentlySelected = !this.showRecentlySelected;
    this.ref.detectChanges();
    setTimeout( () => {
      this.changeFilterTopStyling();
    },0);    
  }

  toggleAllRecentlySelectedRetailers(event) {
    let retailers = [];
    for(let i=0; i < this.recentlySelectedRetailers.length; i++) {
      retailers.push(this.recentlySelectedRetailers[i]);
    }
    if(retailers.length > 0) {
      (<any>window).toggleRetailerFilter(retailers, event.target.checked);
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleAllCategoryRetailers(event) {
    let retailerIds = [],
    w = (<any>window),
    categoryId = parseInt(event.target.id.split('-')[1]),
    category = this.mapsSidebarService.retailerCategories.find((obj)=>{
      return categoryId === obj.categoryId;
    });

    let data = {
      category: category,
      toggle: event.target.checked
    };
    if(category) {
      if(category.retailers && category.retailers.length > 0) {
        w.Events.publish('toggleCategoryRetailers', data);
      } else {
        this.mapsSidebarService.retailerByCategoryIdsApiCall(categoryId, data);
      }
    }
  }

  resetRetailerFilter() {
    let w = (<any>window);
    this.resetCheckedRetailers();
    w.resetRetailerFilter();
    this.showRecentlySelected = false;
    this.openCategoryList = [];
    this.showGoogleBusiness = false;
    this.resetSearchInput();
    w.overlayLayer.toggleGoogleBusiness(false);
    w.setMapDataProperty('showGoogleBusiness', false);
    this.toggleRooftopRetailerSelection('featured');
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
    this.changeFilterTopStyling();
  }

  resetCheckedRetailers() {
    let w = (<any>window);
    if(this.mapsSidebarService.retailerCategories) {
     for(let category of this.mapsSidebarService.retailerCategories) {
        if(category.categoryId) {
          let categoryCheckbox = <HTMLInputElement>document.getElementById('category-'+category.categoryId);
          if(categoryCheckbox && categoryCheckbox.type === 'checkbox') {
            categoryCheckbox.checked = false;
          }
          if(category.retailers) {
            for(let retailers of category.retailers) {
              if(retailers.retailerId) {
                let retailerCheckbox = <HTMLInputElement>document.getElementById('retailercategory-'+category.retailerId);
                if(retailerCheckbox && retailerCheckbox.type === 'checkbox') {
                  retailerCheckbox.checked = false;
                }
              }
            }
          }
        }
      }
    }
    w.Events.publish('detectChanges');
  }

  resetSearchInput() {
    if(this.mapsSidebarService.retailerSearchValue.length > 1) {
      this.mapsSidebarService.retailerSearchValue = '';
      (<HTMLInputElement>document.getElementById('retailer-filter-search-input')).value = '';
      this.apiCallsAfterInput();
    }
  }

  isRetailerDisabled() {
    return (this.isRetailerOn !== undefined)? !(this.isRetailerOn) || this.allRetailersActive() : false;
  }

  toggleVisibility(event) {
    let w = (<any>window);
    this.isRetailerOn = event.target.checked;
    w.apiRetailer.toggleVisible(event.target.checked);
    w.apiRetailer.getTilesInCurrentViewport();
    this.showGoogleBusiness && w.overlayLayer.toggleGoogleBusiness(event.target.checked);
    w.mapData.currentZoomLevel >= w.LEADER_LINES.RETAILER.MIN && w.leaderLines.showLeaderLines();
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
  }

  allRetailersActive() {
    let w = (<any>window);
    return w.apiRetailer? w.apiRetailer.allRetailersVisible() : false; 
  }

  isRecentPartialSelected() {
    let w = (<any>window),
        selectedCount = 0;
    if(w.mapData) { 
      for(var i=0; i < this.recentlySelectedRetailers.length; i++) {
        if(w.checkIfRetailerPresentArray(this.recentlySelectedRetailers[i], w.apiRetailer.filteredRetailers)) {
          selectedCount ++;
        }
      }
      return (selectedCount > 0 && selectedCount < this.recentlySelectedRetailers.length);
    } else {
      return false;
    }
  }

  isCategoryPartialSelected(categoryId) {
    let w = (<any>window)
    if(w.mapData && w.apiRetailer.filteredRetailers.length > 0) { 
      let selectedRetailerOfThisCategory = w.apiRetailer.filteredRetailers.find((obj)=>{
        if(obj.categoryIds) {
          return obj.categoryIds && obj.categoryIds.includes(categoryId);
        } else {
          return obj.categoryId === categoryId;
        }
      });
      return selectedRetailerOfThisCategory ? true : false;
    }
  }

  toggleGoogleBusiness(event) {
    let w = (<any>window);
    this.showGoogleBusiness = !this.showGoogleBusiness;
    w.setMapDataProperty('showGoogleBusiness', this.showGoogleBusiness);
    w.overlayLayer.toggleGoogleBusiness(this.showGoogleBusiness);
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
  }

  showRetailersOnRooftop(type) {
    return (<any>window).mapData.activeRetailersOnRooftop === type;
  }

  toggleRooftopRetailerSelection(event) {
    let w = (<any>window);
    let toggle = event.target && event.target.dataset? event.target.dataset.type: event;
    w.setMapDataProperty('activeRetailersOnRooftop', toggle);
    if (w.onRoofTop()) {
      w.apiRetailer.resetAll();
      w.leaderLines.showLeaderLines();
      if (w.mapData.activeRetailersOnRooftop === 'none') {
        w.apiRetailer.hideRetailers();
      } else {
        w.apiRetailer.getTilesInCurrentViewport();
      }
    }
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
  }

  ngOnDestroy() {
    this.retailerFilterActiveSubscription && this.retailerFilterActiveSubscription.unsubscribe();
    this.mapLoadedChangeSubscription && this.mapLoadedChangeSubscription.unsubscribe();
    this.retailerFiltersChangedSubscription && this.retailerFiltersChangedSubscription.unsubscribe();
    this.tilesLoadedSubscription && this.tilesLoadedSubscription.unsubscribe();
    this.updateRecentlySelectedRetailersSubscription && this.updateRecentlySelectedRetailersSubscription.unsubscribe();
    this.toggleCategoryRetailersSubscription && this.toggleCategoryRetailersSubscription.unsubscribe();
    this.fetchOpenCategoryRetailersSubscription && this.fetchOpenCategoryRetailersSubscription.unsubscribe();
    this.toggleRooftopRetailerSelectionSubscription && this.toggleRooftopRetailerSelectionSubscription.unsubscribe();
    this.toggleGoogleBusinessSubscription && this.toggleGoogleBusinessSubscription.unsubscribe();
    this.resetRecentlySelectedRetailersSubscription && this.resetRecentlySelectedRetailersSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/retailer-filter/retailer-filter.component.ts